/* Vertical Spice — Wholesale Site. Loaded ONLY by layout/wholesale.liquid.
   Retail pages never load this file.
   Kaching Cart's app embed is injected into every layout via content_for_header and it
   hijacks cart clicks with a capture listener registered in <head>. The wholesale site
   uses the native /cart page, so we intercept in the capture phase too. CSS hides its
   drawer; this stops the click ever reaching it. */
(function () {
  /* WINDOW capture, not document capture. Kaching registers a document-level capture
     listener from <head> that preventDefaults cart-link clicks, stopImmediatePropagation()s
     them and opens its (hidden) drawer, so a document listener registered later never runs
     (proven live 2026-09-02: cart icon clicks died silently). The capture path is
     window -> document -> target, so window fires first; stopPropagation() here means
     Kaching's document listener never sees the event. */
  window.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest(
      '[data-cart-drawer-toggle],[aria-controls="cart-drawer"],a[href$="/cart"],a[href*="/cart?"],.nav-v-bar__icon--cart,[data-kaching-checkout]'
    );
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = (window.vsWholesaleCartUrl || '/cart');
  }, true);
}());

/* SCROLL NOTE 2026-09-02: on any cart add, Kaching adds `kaching-body__cart-open` to <html>
   and <body> (its drawer "opened"; the drawer is display:none here so nothing closes it) and
   its stylesheet sets overflow:clip on the root, freezing scroll. The fix is CSS-ONLY, in
   wholesale.css: forcing overflow back while the class sits there. Do NOT "clean up" the
   class from JS: Kaching re-adds it from its own observer and the strip/re-add ping-pong
   pegged the main thread so hard the page never reached DOMContentLoaded. */

/* Adding to cart never goes through a form submit or a theme drawer on the wholesale site:
   every add is a direct /cart/add.js call from our own click handlers. theme.dev.js and app
   embeds register their own submit/drawer machinery in <head>, and their "open the drawer"
   step targets markup this layout does not render, which is how adds looked like nothing
   happened. */
function vswAddToCart(variantId, qty, onOk, onErr) {
  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  }).then(function (r) {
    if (!r.ok) throw new Error('add failed ' + r.status);
    return r.json();
  }).then(onOk).catch(onErr);
}

/* BSS notification helpers. BSS re-prices only when the hidden input[name="id"] fires a NATIVE
   change event inside a [bss-b2b-main-product-form] wrapper (the July gotcha), and it only
   scans content present at init unless its custom init event is fired for late-inserted DOM. */
function vswNotifyBss(idInput, priceEl, variantId) {
  if (priceEl) priceEl.setAttribute('bss-b2b-variant-id', String(variantId));
  try { idInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
}
function vswBssInitLate() {
  ['bss_b2b:CustomInitProductSubject', 'bss_b2b:CustomInitCartSubject'].forEach(function (n) {
    try { window.dispatchEvent(new CustomEvent(n)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent(n)); } catch (e) {}
  });
}

/* Dealer price for one variant, through BSS's own pricing engine.
   BSS's DOM scanner never activates a price element created after page load (proven live
   2026-09-02: the Quick Add price stayed visibility:hidden with no bss-b2b-product-active),
   so the modal asks BSS_B2B.integrateUtils.calculateB2BPrice directly. It applies the
   signed-in customer's custom-pricing rules (verified with a simulated ws-40 customer:
   applyCP set, modifyPrice returned). Returns {cents, text} or null for no discount. */
function vswDealerPrice(d, v) {
  var B = window.BSS_B2B;
  if (!B || !B.integrateUtils || typeof B.integrateUtils.calculateB2BPrice !== 'function') return null;
  if (!B.shopData || !B.shopData.customer) return null;
  try {
    /* BSS's checkProduct reads camelCase: {productId, variantId, collectionIds, tags}
       (bss-b2b-integrate.js). An "All products" rule short-circuits on ALL and never reads
       them, which is why snake_case alone worked until the ws-40 rule was scoped to specific
       variants on 2026-09-07 and Quick Add fell back to retail. Send both spellings. */
    var item = { price: v.cents, id: v.id, variant_id: v.id, product_id: d.id, handle: d.handle,
      productId: d.id, variantId: v.id, collectionIds: [], tags: d.tags || [],
      product_tags: d.tags || [], collections: [],
      product: { id: d.id, tags: d.tags || [], collections: [] }, variant: { id: v.id, price: v.cents } };
    var r = B.integrateUtils.calculateB2BPrice([item], false, null);
    var out = r && r[0];
    var mp = out && (out.modifyPrice != null ? out.modifyPrice : out.modifyPriceAfterPlCpQb);
    if (typeof mp !== 'number' || !(mp < v.cents)) return null;
    var text;
    try { text = B.formatMoney(mp); } catch (e) { text = '$' + (mp / 100).toFixed(2); }
    return { cents: mp, text: text };
  } catch (e) { return null; }
}

/* ---- Card data registry ----
   Each grid section emits <script type="application/json" data-vsw-cards="{section id}">, an
   array index-mapped to its .grid__item children, exactly like the facet blob. Used by the
   tape bars, the hover image and the Quick Add modal. */
var vswCardStore = (function () {
  var bySection = [];

  function enhanceCard(item, d) {
    if (!d || item.hasAttribute('data-vsw-enhanced')) return;
    item.setAttribute('data-vsw-enhanced', '1');

    /* Tape-bar dims, same look as the selector's vs-tape-row. */
    var sub = item.querySelector('.product-subtitle');
    if (sub && d.dims && d.dims.w) {
      var w = parseFloat(d.dims.w), h = parseFloat(d.dims.h), dp = parseFloat(d.dims.d);
      if (w && h && dp) {
        var row = document.createElement('div');
        row.className = 'vsw-tape-row';
        [[w, 'Wide', ''], [h, 'Tall', ''], [dp, 'Deep', ' vsw-tape-bar--depth']].forEach(function (t) {
          var bar = document.createElement('div');
          bar.className = 'vsw-tape-bar' + t[2];
          bar.style.flex = String(t[0]);
          var lab = document.createElement('span');
          lab.className = 'vsw-tape-label';
          lab.textContent = t[0] + '" ' + t[1];
          bar.appendChild(lab);
          row.appendChild(bar);
        });
        sub.textContent = '';
        sub.appendChild(row);
      }
    }

    /* SKU pill + tier for 1.5-tier units. The retail card builds its pill and "N-Tier" from the
       handle split on "-", and handles write 1.5 as "1-5", so 222x1.5x11 showed "222X1" and
       "1-Tier". Rebuild both from the variant SKU (e.g. 222x1.5x11DC) instead. */
    (function () {
      var sku = (d.variants && d.variants[0] && d.variants[0].sku) || '';
      var m = sku.match(/^(\d+x[\d.]+x\d+)/i);
      if (!m) return;
      var code = m[1];
      var pill = item.querySelector('.collection-sku-pill');
      if (pill) pill.textContent = code.toUpperCase();
      var tier = code.split('x')[1];
      var t = item.querySelector('.product-grid-item__title');
      if (t && tier && /\|\s*[\d.]+-Tier/.test(t.textContent)) {
        t.textContent = t.textContent.replace(/\|\s*[\d.]+-Tier/, '| ' + tier + '-Tier');
      }
    }());

    /* Hover second image. */
    if (d.images && d.images.length > 1) {
      var box = item.querySelector('.product__media__container');
      if (box && !box.querySelector('.vsw-hover-img')) {
        var img = document.createElement('img');
        img.className = 'vsw-hover-img';
        img.loading = 'lazy';
        img.alt = '';
        img.src = d.images[1];
        box.appendChild(img);
      }
    }

    /* Quick add. The retail button has no handler here (its JS lives in the retail
       collection section this layout never renders), so it is ours to own. */
    var btn = item.querySelector('.collection-atc');
    if (btn) {
      btn.textContent = 'QUICK ADD';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        vswOpenQuickAdd(d, item.getAttribute('data-vsw-color'));
      });
    }

    /* Color dots. The retail swatch element is defined on this layout but its handlers do
       nothing here (no image swap, no navigation), so the dots own their behaviour: swap the
       card photo to that color's variant image, point the card links at that variant, and
       remember the color so Quick Add opens with it selected. Capture + stopPropagation keeps
       theme.dev.js's own swatch handling out of the way. */
    var swatches = item.querySelectorAll('.swatch__button');
    /* Mark the card's current color on load (the first available variant's Color), so the
       selected state is visible before any click, like the selector's cards. */
    (function () {
      var ci = (d.optionNames || []).indexOf('Color');
      if (ci === -1 || !swatches.length) return;
      var v = (d.variants || []).find(function (x) { return x.available; }) || d.variants[0];
      var color = v && v.options[ci];
      swatches.forEach(function (sb) {
        if (sb.getAttribute('data-value') === color) { sb.classList.add('vsw-swatch-on'); item.setAttribute('data-vsw-color', color); }
      });
    }());
    swatches.forEach(function (sb) {
      sb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var lab = sb.querySelector('.swatch__label');
        var color = sb.getAttribute('data-value');
        var vid = lab && lab.getAttribute('data-swatch-variant');
        var src = lab && lab.getAttribute('data-swatch-image');
        swatches.forEach(function (x) { x.classList.remove('vsw-swatch-on'); });
        sb.classList.add('vsw-swatch-on');
        if (color) item.setAttribute('data-vsw-color', color);
        var box = item.querySelector('.product__media__container');
        if (box && src) {
          var ov = box.querySelector('.vsw-swatch-img');
          if (!ov) { ov = document.createElement('img'); ov.className = 'vsw-swatch-img'; ov.alt = ''; box.appendChild(ov); }
          ov.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=800';
        }
        if (vid) {
          item.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
            var base = (a.getAttribute('href') || '').split('?')[0];
            a.setAttribute('href', base + '?variant=' + vid + '&view=wholesale');
          });
        }
      }, true);
    });

    /* Warm the modal's hero image while the mouse is still over the card, so Quick Add
       opens with the photo already cached instead of visibly loading (the "slow" feel). */
    item.addEventListener('mouseenter', function () {
      if (item.hasAttribute('data-vsw-warm')) return;
      item.setAttribute('data-vsw-warm', '1');
      if (d.images && d.images[0]) { var pre = new Image(); pre.src = d.images[0]; }
    }, { once: false });
  }

  function enhanceSection(entry) {
    var items = Array.prototype.filter.call(entry.grid.children, function (n) {
      return n.classList && n.classList.contains('grid__item');
    });
    items.forEach(function (item, i) { enhanceCard(item, entry.cards[i]); });
  }

  function register(scriptEl) {
    var cards;
    try { cards = JSON.parse(scriptEl.textContent); } catch (e) { return; }
    /* The products-grid section emits its JSON after </section> (next to the facet blob), so
       closest() alone finds nothing there; resolve the container by its section-id id first. */
    var sid = scriptEl.getAttribute('data-vsw-cards');
    var container = document.getElementById('vsw-pg-' + sid) ||
                    document.getElementById('vsw-bs-' + sid) ||
                    scriptEl.closest('.vsw-section');
    var grid = container && (container.querySelector('[data-vsw-grid]') || container.querySelector('.grid'));
    if (!grid || !cards || !cards.length) return;
    var entry = { id: sid, grid: grid, cards: cards };
    bySection.push(entry);
    enhanceSection(entry);
  }

  function append(sectionId, cards) {
    for (var i = 0; i < bySection.length; i++) {
      if (bySection[i].id === sectionId) {
        bySection[i].cards = bySection[i].cards.concat(cards);
        enhanceSection(bySection[i]);
        return;
      }
    }
  }

  function boot() {
    document.querySelectorAll('script[data-vsw-cards]').forEach(register);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  return { append: append };
}());

/* ---- Quick Add modal ----
   Opened from any grid card. Layout mirrors the retail offer-page popup Saksham referenced:
   gallery left; title, dims, price, option pills, quantity, add, full-details link right.
   The wrapper carries the full BSS attribute set and fires BSS's late-init events so
   wholesale re-pricing can attach to a modal that did not exist at page load. */
function vswOpenQuickAdd(d, preColor) {
  var old = document.querySelector('[data-vsw-qa]');
  if (old) old.remove();

  var chosen = null;
  for (var i = 0; i < d.variants.length; i++) {
    if (d.variants[i].available) { chosen = d.variants[i].options.slice(); break; }
  }
  if (!chosen) chosen = d.variants[0].options.slice();
  /* A color picked on the card's dots carries into the modal, if that combination exists. */
  if (preColor) {
    var ci = d.optionNames.indexOf('Color');
    if (ci !== -1) {
      var trial = chosen.slice(); trial[ci] = preColor;
      var ok = d.variants.some(function (v) { return v.options.every(function (o, i) { return o === trial[i]; }); });
      if (ok) chosen = trial;
    }
  }

  var wrap = document.createElement('div');
  wrap.className = 'vsw-qa';
  wrap.setAttribute('data-vsw-qa', '');

  var dimsLine = (d.dims && d.dims.w)
    ? d.dims.w + ' Wide &times; ' + d.dims.h + ' Tall &times; ' + d.dims.d + ' Deep'
    : '';
  var fullUrl = d.url + (d.url.indexOf('?') === -1 ? '?' : '&') + 'view=wholesale';

  /* Display order: Assembly first, then the rest (matches the PDP). optIdx keeps the TRUE
     option index so variant matching is unaffected by display order. */
  var order = [];
  d.optionNames.forEach(function (n, idx) { if (n === 'Assembly') order.push(idx); });
  d.optionNames.forEach(function (n, idx) { if (n !== 'Assembly') order.push(idx); });

  var optsHtml = '';
  order.forEach(function (optIdx) {
    var vals = [];
    d.variants.forEach(function (v) {
      if (vals.indexOf(v.options[optIdx]) === -1) vals.push(v.options[optIdx]);
    });
    if (vals.length < 2 && d.optionNames.length === 1 && vals[0] === 'Default Title') return;
    optsHtml += '<div class="vsw-opt"><span class="vsw-opt__label">' + d.optionNames[optIdx] + '</span><div class="vsw-opt__vals">';
    var isColor = d.optionNames[optIdx] === 'Color';
    vals.forEach(function (val) {
      var safe = val.replace(/"/g, '&quot;');
      if (isColor) {
        optsHtml += '<button type="button" class="vsw-opt__val vsw-opt__val--swatch" data-qa-opt="' + optIdx + '" data-qa-val="' + safe + '"><i class="vsw-sw vsw-sw--' + val.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '" aria-hidden="true"></i>' + val + '</button>';
      } else {
        optsHtml += '<button type="button" class="vsw-opt__val" data-qa-opt="' + optIdx + '" data-qa-val="' + safe + '">' + val + '</button>';
      }
    });
    optsHtml += '</div></div>';
  });

  var galleryHtml = '<img data-qa-img src="' + (d.images[0] || '') + '" alt="">';
  if (d.images.length > 1) {
    galleryHtml += '<button type="button" class="vsw-qa__nav vsw-qa__nav--prev" data-qa-prev aria-label="Previous image">&#8249;</button>' +
      '<button type="button" class="vsw-qa__nav vsw-qa__nav--next" data-qa-next aria-label="Next image">&#8250;</button>' +
      '<span class="vsw-qa__count"><span data-qa-count>1</span> / ' + d.images.length + '</span>';
  }

  wrap.innerHTML =
    '<div class="vsw-qa__box" bss-b2b-main-product-form role="dialog" aria-label="' + d.title.replace(/"/g, '&quot;') + '">' +
      '<button type="button" class="vsw-qa__close" data-qa-close aria-label="Close">&#10005;</button>' +
      '<div class="vsw-qa__media">' + galleryHtml + '</div>' +
      '<div class="vsw-qa__info">' +
        '<h3>' + d.title + '</h3>' +
        (dimsLine ? '<p class="vsw-qa__dims">' + dimsLine + '</p>' : '') +
        '<div class="vsw-qa__price"><span data-qa-price></span></div>' +
        '<p class="vsw-qa__sku">SKU <span data-qa-sku></span></p>' +
        '<input type="hidden" name="id" data-qa-id>' +
        optsHtml +
        '<div class="vsw-qa__qty"><label>Quantity</label>' +
          '<span class="vsw-qa__stepper">' +
            '<button type="button" data-qa-minus aria-label="Decrease">&minus;</button>' +
            '<input type="number" value="1" min="1" data-qa-qty aria-label="Quantity">' +
            '<button type="button" data-qa-plus aria-label="Increase">+</button>' +
          '</span>' +
        '</div>' +
        '<button type="button" class="vsw-btn vsw-qa__add" data-qa-add>Add to cart</button>' +
        '<div class="vsw-qa__added" data-qa-added hidden>' +
          '<span class="vsw-qa__added-msg">&#10003; Added to your cart</span>' +
          '<div class="vsw-qa__added-actions">' +
            '<a class="vsw-btn vsw-qa__viewcart" href="' + (window.vsWholesaleCartUrl || '/cart') + '">View cart</a>' +
            '<button type="button" class="vsw-qa__continue" data-qa-close>Continue shopping</button>' +
          '</div>' +
        '</div>' +
        '<a class="vsw-qa__full" href="' + fullUrl + '">See full details</a>' +
      '</div>' +
    '</div>';

  document.body.appendChild(wrap);

  var idInput = wrap.querySelector('[data-qa-id]');
  var priceEl = wrap.querySelector('[data-qa-price]');
  var skuEl   = wrap.querySelector('[data-qa-sku]');
  var addBtn  = wrap.querySelector('[data-qa-add]');
  var addedEl = wrap.querySelector('[data-qa-added]');
  var imgEl   = wrap.querySelector('[data-qa-img]');
  var countEl = wrap.querySelector('[data-qa-count]');
  var qtyEl   = wrap.querySelector('[data-qa-qty]');
  var imgAt   = 0;

  function findVariant() {
    return d.variants.find(function (v) {
      for (var i = 0; i < d.optionNames.length; i++) {
        if (v.options[i] !== chosen[i]) return false;
      }
      return true;
    });
  }

  function select() {
    var v = findVariant();
    wrap.querySelectorAll('[data-qa-opt]').forEach(function (b) {
      var on = chosen[parseInt(b.getAttribute('data-qa-opt'), 10)] === b.getAttribute('data-qa-val');
      b.classList.toggle('is-on', on);
    });
    if (!v) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      return;
    }
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    addedEl.hidden = true;
    var deal = vswDealerPrice(d, v);
    if (deal) {
      priceEl.innerHTML = '<s class="vsw-qa__was"></s> <b class="vsw-qa__now"></b>';
      priceEl.querySelector('.vsw-qa__was').textContent = v.price;
      priceEl.querySelector('.vsw-qa__now').textContent = deal.text;
    } else {
      priceEl.textContent = v.price;
    }
    skuEl.textContent = v.sku || '';
    idInput.value = v.id;
    if (v.image) { imgEl.src = v.image; }
  }

  function showImg(i) {
    if (!d.images.length) return;
    imgAt = (i + d.images.length) % d.images.length;
    imgEl.src = d.images[imgAt];
    if (countEl) countEl.textContent = imgAt + 1;
  }

  wrap.querySelectorAll('[data-qa-opt]').forEach(function (b) {
    b.addEventListener('click', function () {
      chosen[parseInt(b.getAttribute('data-qa-opt'), 10)] = b.getAttribute('data-qa-val');
      select();
    });
  });
  var prev = wrap.querySelector('[data-qa-prev]');
  var next = wrap.querySelector('[data-qa-next]');
  if (prev) prev.addEventListener('click', function () { showImg(imgAt - 1); });
  if (next) next.addEventListener('click', function () { showImg(imgAt + 1); });
  wrap.querySelector('[data-qa-minus]').addEventListener('click', function () {
    qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) - 1);
  });
  wrap.querySelector('[data-qa-plus]').addEventListener('click', function () {
    qtyEl.value = (parseInt(qtyEl.value, 10) || 1) + 1;
  });

  addBtn.addEventListener('click', function () {
    var v = findVariant();
    if (!v || !v.available) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';
    vswAddToCart(v.id, parseInt(qtyEl.value, 10) || 1, function () {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart';
      addedEl.hidden = false;
    }, function () {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart';
      alert('Could not add to cart. Please try again.');
    });
  });

  function close() {
    wrap.remove();
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  wrap.querySelectorAll('[data-qa-close]').forEach(function (b) { b.addEventListener('click', close); });
  wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
  document.addEventListener('keydown', onKey);

  select();
}

/* ---- Search overlay ----
   /search/suggest.json with resources[type]=product keeps pages and articles out. Results
   deliberately show no price: BSS re-prices only elements present at page load, so a price
   here would show retail to a signed-in dealer. */
(function () {
  var overlay, input, results, timer;

  function open() {
    overlay.hidden = false;
    input.focus();
  }
  function close() {
    overlay.hidden = true;
    input.value = '';
    results.innerHTML = '<p class="vsw-search__hint">Type a size or product name.</p>';
  }

  function render(products) {
    if (!products.length) {
      results.innerHTML = '<p class="vsw-search__hint">No products match that.</p>';
      return;
    }
    var frag = document.createDocumentFragment();
    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'vsw-search__item';
      a.href = p.url.split('?')[0] + '?view=wholesale';
      var img = document.createElement('img');
      img.src = (p.featured_image && p.featured_image.url) || p.image || '';
      img.alt = '';
      img.loading = 'lazy';
      var txt = document.createElement('div');
      var b = document.createElement('b');
      b.textContent = p.title;
      txt.appendChild(b);
      a.appendChild(img);
      a.appendChild(txt);
      frag.appendChild(a);
    });
    results.innerHTML = '';
    results.appendChild(frag);
  }

  function search(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        render((d.resources && d.resources.results && d.resources.results.products) || []);
      })
      .catch(function () {
        results.innerHTML = '<p class="vsw-search__hint">Search is unavailable right now.</p>';
      });
  }

  function boot() {
    overlay = document.querySelector('[data-vsw-search]');
    if (!overlay) return;
    input = overlay.querySelector('[data-vsw-search-input]');
    results = overlay.querySelector('[data-vsw-search-results]');
    document.querySelectorAll('[data-vsw-search-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    overlay.querySelector('[data-vsw-search-close]').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '<p class="vsw-search__hint">Type a size or product name.</p>';
        return;
      }
      timer = setTimeout(function () { search(q); }, 250);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());

/* ---- Wholesale product listing: facets + auto-load the full catalog ----
   Facet rows come from a JSON <script> emitted by sections/wholesale-product-grid.liquid and
   are matched to .grid__item BY INDEX, which is why the retail card snippet never had to be
   modified. On load every remaining page is fetched in the background (cards, facet rows AND
   card data merged), so filters always cover the whole catalog and the user never has to know
   pagination exists. The Load More button is the visible fallback if a fetch fails. */
(function () {
  var FACETS = [
    { key: 'depth',    label: 'Depth' },
    { key: 'width',    label: 'Width' },
    { key: 'assembly', label: 'Assembly' },
    { key: 'color',    label: 'Color' }
  ];

  function initSection(dataEl) {
    var sectionId = dataEl.getAttribute('data-vsw-facets');
    var facets;
    try { facets = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var root = document.getElementById('vsw-pg-' + sectionId);
    if (!root || !facets || !facets.length) return;

    var section = root.closest('.vsw-section');
    var grid    = section.querySelector('[data-vsw-grid]');
    var rowsEl  = section.querySelector('[data-vsw-rows]');
    var wrapEl  = section.querySelector('[data-vsw-filters]');
    var clearEl = section.querySelector('[data-vsw-clear]');
    var emptyEl = section.querySelector('[data-vsw-empty]');
    var moreBtn = section.querySelector('[data-vsw-more]');
    var active  = {};

    function items() {
      return Array.prototype.filter.call(grid.children, function (n) {
        return n.classList && n.classList.contains('grid__item');
      });
    }

    function valuesFor(key) {
      var seen = [];
      facets.forEach(function (f) {
        var v = f[key];
        (Array.isArray(v) ? v : [v]).forEach(function (x) {
          x = (x || '').trim();
          if (x && seen.indexOf(x) === -1) seen.push(x);
        });
      });
      return seen.sort(function (a, b) {
        var na = parseFloat(a), nb = parseFloat(b);
        if (!isNaN(na) && !isNaN(nb)) return na - nb;
        return a.localeCompare(b);
      });
    }

    /* Numeric-aware equality so a ?depth=13.8 deep link matches the '13.8"' facet value. */
    function sameVal(a, b) {
      if (a === b) return true;
      var na = parseFloat(a), nb = parseFloat(b);
      return !isNaN(na) && !isNaN(nb) && na === nb;
    }

    function matches(f) {
      var ok = FACETS.every(function (fc) {
        var want = active[fc.key];
        if (!want || !want.length) return true;
        var have = f[fc.key];
        have = (Array.isArray(have) ? have : [have]).map(function (x) { return (x || '').trim(); });
        return want.some(function (w) { return have.some(function (h) { return sameVal(h, w); }); });
      });
      if (!ok) return false;
      /* Color + Assembly together must exist on ONE variant (e.g. "Maple DIY"), not merely
         somewhere across the product. Combos come from the SKUs, e.g. "Maple|Ready-made". */
      var wc = active.color || [], wa = active.assembly || [];
      if (wc.length && wa.length && Array.isArray(f.combos)) {
        return f.combos.some(function (cb) {
          var p = cb.split('|');
          return wc.indexOf(p[0]) !== -1 && wa.indexOf(p[1]) !== -1;
        });
      }
      return true;
    }

    function apply() {
      var els = items(), shown = 0;
      facets.forEach(function (f, i) {
        if (!els[i]) return;
        var ok = matches(f);
        els[i].style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      emptyEl.hidden = shown !== 0;
      clearEl.hidden = !FACETS.some(function (fc) { return active[fc.key] && active[fc.key].length; });
      syncDepthButtons();
    }

    /* Built via a helper, not inline in the loop: `var` is function-scoped and inlining makes
       every chip close over the last facet. Same bug that broke the FAQ accordions. */
    function makeChip(key, value) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vsw-facet__chip';
      b.textContent = value;
      if ((active[key] || []).some(function (x) { return sameVal(x, value); })) b.classList.add('is-on');
      b.addEventListener('click', function () {
        active[key] = active[key] || [];
        var at = -1;
        active[key].forEach(function (x, i) { if (at === -1 && sameVal(x, value)) at = i; });
        if (at === -1) { active[key].push(value); b.classList.add('is-on'); }
        else { active[key].splice(at, 1); b.classList.remove('is-on'); }
        apply();
      });
      return b;
    }

    /* Two lines (Saksham round 2): Depth + Width first, Assembly + Color second. */
    function buildChips() {
      rowsEl.innerHTML = '';
      [['depth', 'width'], ['assembly', 'color']].forEach(function (lineKeys) {
        var line = document.createElement('div');
        line.className = 'vsw-facet-line';
        FACETS.forEach(function (fc) {
          if (lineKeys.indexOf(fc.key) === -1) return;
          var vals = valuesFor(fc.key);
          if (vals.length < 2) return;
          var row = document.createElement('div');
          row.className = 'vsw-facet';
          var lab = document.createElement('span');
          lab.className = 'vsw-facet__label';
          lab.textContent = fc.label;
          row.appendChild(lab);
          var chips = document.createElement('div');
          chips.className = 'vsw-facet__chips';
          vals.forEach(function (v) { chips.appendChild(makeChip(fc.key, v)); });
          row.appendChild(chips);
          line.appendChild(row);
        });
        if (line.children.length) rowsEl.appendChild(line);
      });
      wrapEl.hidden = rowsEl.children.length === 0;
    }

    if (clearEl) {
      clearEl.addEventListener('click', function () {
        active = {};
        buildChips();
        apply();
      });
    }

    /* Big "shop by cabinet depth" buttons: single-select over the Depth facet, click again to
       clear. ?depth=13.8 on the URL (from the home strip or a sales email) pre-selects. */
    var depthBtns = section.querySelectorAll('[data-vsw-depth]');
    function syncDepthButtons() {
      depthBtns.forEach(function (b) {
        var on = (active.depth || []).some(function (x) { return sameVal(x, b.getAttribute('data-vsw-depth')); });
        b.classList.toggle('is-on', on);
      });
    }
    depthBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-vsw-depth');
        var on = (active.depth || []).some(function (x) { return sameVal(x, v); });
        active.depth = on ? [] : [v];
        buildChips();
        apply();
      });
    });
    var qDepth = new URLSearchParams(window.location.search).get('depth');
    if (qDepth) active.depth = [qDepth];

    function loadNext(done) {
      var url = moreBtn && moreBtn.getAttribute('data-vsw-next');
      if (!url) { done(false); return; }
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-vsw-grid]');
          var newData = doc.querySelector('[data-vsw-facets]');
          if (!newGrid || !newData) throw new Error('unexpected page shape');

          Array.prototype.slice.call(newGrid.children).forEach(function (n) {
            if (n.classList && n.classList.contains('grid__item')) grid.appendChild(n);
          });
          facets = facets.concat(JSON.parse(newData.textContent));

          var newCards = doc.querySelector('script[data-vsw-cards]');
          if (newCards) {
            try { vswCardStore.append(newCards.getAttribute('data-vsw-cards'), JSON.parse(newCards.textContent)); } catch (e) {}
          }

          var nextBtn = doc.querySelector('[data-vsw-more]');
          moreBtn.setAttribute('data-vsw-next', nextBtn ? nextBtn.getAttribute('data-vsw-next') : '');
          buildChips();
          apply();
          done(!!nextBtn);
        })
        .catch(function () { done(null); });
    }

    if (moreBtn) {
      /* Auto-walk every page. The button stays hidden unless a fetch fails. */
      moreBtn.style.display = 'none';
      function walk() {
        loadNext(function (hasMore) {
          if (hasMore === null) {
            moreBtn.style.display = '';
            moreBtn.textContent = 'Load more';
            return;
          }
          if (hasMore) walk();
          else if (moreBtn.parentElement) moreBtn.parentElement.remove();
        });
      }
      moreBtn.addEventListener('click', function () {
        if (moreBtn.disabled) return;
        moreBtn.disabled = true;
        moreBtn.textContent = 'Loading...';
        loadNext(function (hasMore) {
          moreBtn.disabled = false;
          moreBtn.textContent = 'Load more';
          if (hasMore === false && moreBtn.parentElement) moreBtn.parentElement.remove();
        });
      });
      walk();
    }

    buildChips();
    apply();
  }

  function boot() {
    document.querySelectorAll('[data-vsw-facets]').forEach(initSection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());

/* ---- Wholesale PDP variant switching ----
   BSS re-prices ONLY when the hidden input[name="id"] fires a NATIVE `change` event and it can
   resolve an ancestor marked [bss-b2b-main-product-form]. Setting .value from JS does not fire
   that event, which is exactly the bug that made wholesale prices stick at retail in July.
   So: set the id, update bss-b2b-variant-id on the price element, THEN dispatch a real change.
   The re-fire on a timer covers BSS re-rendering the price node after we touched it. */
(function () {
  var data = window.vswProduct;
  if (!data) return;
  var form = document.querySelector('[data-vsw-form]');
  if (!form) return;

  var idInput  = form.querySelector('[data-vsw-id]');
  var priceEl  = document.querySelector('[data-vsw-price]');
  var skuEl    = document.querySelector('[data-vsw-sku]');
  var addBtn   = form.querySelector('[data-vsw-add]');
  var unavail  = form.querySelector('[data-vsw-unavailable]');
  var gallery  = document.querySelector('[data-vsw-gallery]');
  var chosen   = [];

  document.querySelectorAll('.vsw-opt__val.is-on').forEach(function (b) {
    chosen[parseInt(b.dataset.vswOpt, 10)] = b.dataset.vswVal;
  });

  function findVariant() {
    return data.variants.find(function (v) {
      for (var i = 0; i < data.optionCount; i++) {
        if (v.options[i] !== chosen[i]) return false;
      }
      return true;
    });
  }

  function select() {
    var v = findVariant();
    if (!v) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      if (unavail) unavail.hidden = false;
      return;
    }
    if (unavail) unavail.hidden = true;
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';

    idInput.value = v.id;
    if (priceEl) priceEl.textContent = v.price;   // retail price; BSS overwrites it for wholesale
    if (skuEl) skuEl.textContent = v.sku || '';
    // a variant with its own image: swap the visible slide rather than fighting the gallery
    if (v.image && gallery) {
      var active = gallery.querySelector('.vsw-gallery__img.is-on');
      if (active) active.src = v.image;
    }

    vswNotifyBss(idInput, priceEl, v.id);
    setTimeout(function () { vswNotifyBss(idInput, priceEl, v.id); }, 300);
  }

  document.querySelectorAll('.vsw-opt__val').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var i = parseInt(btn.dataset.vswOpt, 10);
      chosen[i] = btn.dataset.vswVal;
      btn.parentElement.querySelectorAll('.vsw-opt__val').forEach(function (b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      select();
    });
  });

  /* Add to cart, our own path end to end. */
  function doAdd() {
    var v = findVariant();
    if (!v || !v.available) return;
    var qty = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';
    vswAddToCart(v.id, qty, function () {
      window.location.href = (window.vsWholesaleCartUrl || '/cart');
    }, function () {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart';
      alert('Could not add to cart. Please try again.');
    });
  }
  addBtn.addEventListener('click', doAdd);
  form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(); });
}());

/* ---- PDP gallery: arrows + thumbs ---- */
(function () {
  var gal = document.querySelector('[data-vsw-gallery]');
  if (!gal) return;
  var slides = Array.prototype.slice.call(gal.querySelectorAll('.vsw-gallery__img'));
  var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-vsw-thumb]'));
  var counter = gal.querySelector('[data-vsw-current]');
  if (slides.length < 2) return;
  var at = 0;

  function show(i) {
    at = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) { s.classList.toggle('is-on', n === at); });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === at); });
    if (counter) counter.textContent = at + 1;
  }

  var prev = gal.querySelector('[data-vsw-prev]');
  var next = gal.querySelector('[data-vsw-next]');
  if (prev) prev.addEventListener('click', function () { show(at - 1); });
  if (next) next.addEventListener('click', function () { show(at + 1); });
  thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });

  gal.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') show(at - 1);
    if (e.key === 'ArrowRight') show(at + 1);
  });
  gal.setAttribute('tabindex', '0');
}());

/* ---- Static accordions (PDP) ----
   Separate from the FAQ builder: these are authored in Liquid, so we only bind toggles.
   Bound per element via a helper, not inline in a loop, for the same `var` scoping reason. */
(function () {
  function bind(btn) {
    var item = btn.closest('.vsw-acc');
    var panel = item && item.querySelector('.vsw-acc__a');
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-vsw-acc]').forEach(bind);
}());


/* ---- Keep product links on the wholesale PDP ----
   The grid reuses the RETAIL card snippet, which builds hrefs from {{ product.url }} with no
   ?view=. Without this a dealer clicking a card lands on the full retail PDP. Rewriting the
   hrefs here means the retail snippet still never has to be modified. Runs after the grid is
   in the DOM and again on any later DOM insertion (quick views, lazy sections). */
(function () {
  function tag(root) {
    (root || document).querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.indexOf('view=wholesale') !== -1) return;
      if (href.indexOf('/products/') === -1) return;
      a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'view=wholesale');
    });
  }
  function boot() {
    tag(document);
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) tag(n); });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());


/* ---- Wholesale cart page controls ----
   /cart?view=wholesale. Quantity and remove go through /cart/change.js (1-based line index),
   then reload so Liquid re-renders totals and BSS re-prices on the fresh DOM.
   DELEGATED on document on purpose: BSS re-renders the cart lines when it re-prices, which
   threw away per-button listeners and made +/- work "sometimes". */
(function () {
  if (!document.querySelector('[data-vsw-line]')) return;
  var busy = false;

  /* Order notes: saved through /cart/update.js on blur/change (and debounced while typing),
     because +/- reloads the page and would lose unsaved text. The textarea is also
     name="note" inside the checkout form, so the native post carries it as well.
     change() waits for any in-flight note save so a blur-then-click never loses the note. */
  var notePending = Promise.resolve();
  var noteSaved = null;
  var noteTimer = null;
  /* BSS Net Terms builds its order note from BSS_B2B.shopData.cart.note, which is the value
     Liquid printed at PAGE LOAD (bss-b2b-store-data), not a fresh /cart.js read. Mirror every
     keystroke into it so "Pay later" carries the note without a reload. */
  function syncNoteToBss(val) {
    try { if (window.BSS_B2B && BSS_B2B.shopData && BSS_B2B.shopData.cart) BSS_B2B.shopData.cart.note = val; } catch (e) {}
  }
  function saveNote(val) {
    syncNoteToBss(val);
    if (val === noteSaved) return notePending;
    noteSaved = val;
    notePending = fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: val })
    }).catch(function () { noteSaved = null; });
    return notePending;
  }
  var noteEl = document.querySelector('[data-vsw-cart-note]');
  if (noteEl) {
    noteSaved = noteEl.value;
    noteEl.addEventListener('input', function () {
      syncNoteToBss(noteEl.value);
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { saveNote(noteEl.value); }, 600);
    });
    noteEl.addEventListener('blur', function () { clearTimeout(noteTimer); saveNote(noteEl.value); });
  }

  /* Saksham 2026-09-10, three defects proven by replaying the shipped handlers against the
     real cart markup with fetch stubbed. Do not "simplify" this back.

     1. Every action fired a request and then reloaded the whole page (941ms measured), while
        the quantity box still showed the OLD number. Nothing on screen moved for about a
        second, so it read as a dead click.
     2. `busy` early-returned with no feedback, so any second action inside that second was
        swallowed in silence. "minus, minus, Remove" sent ONE request (quantity 1) and dropped
        the other two.
     3. Typing a quantity and then clicking Remove fired only the quantity change. The input's
        `change` fires on blur, which happens on mousedown, so it won the race and the click
        was then eaten by `busy`. Remove genuinely did nothing.

     The shape now: the number moves immediately, the row shows it is working, and repeated
     clicks are batched into ONE request after 450ms of quiet instead of being dropped. Remove
     skips the debounce but cancels anything pending for that line. The reload stays, because
     BSS re-prices on a freshly rendered DOM and a partial re-render risks showing a dealer the
     wrong price. */
  var DEBOUNCE = 450;
  var timers = {};       /* line number -> pending debounce timer */
  var pressing = false;  /* a cart button is being pressed, so ignore the blur-fired change */

  /* Last quantity we know the server has, per line. Needed to undo a blank box: clearing the
     field to retype it and then pressing Enter used to parse as 0 and DELETE the line
     (confirmed live, a 2-line cart came back with 1). Blank is not an intent, so it reverts. */
  var lastQty = {};
  Array.prototype.forEach.call(document.querySelectorAll('[data-vsw-line]'), function (row) {
    var input = row.querySelector('[data-vsw-cart-qty]');
    if (input) lastQty[parseInt(row.getAttribute('data-vsw-line'), 10)] = input.value;
  });

  /* The typed quantity, or null when the box holds nothing usable. Typing an explicit 0 is a
     real instruction and still removes the line; empty is not. */
  function typedQty(L) {
    var raw = (L.qty.value || '').trim();
    if (raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : Math.max(0, n);
  }
  function revert(L) { L.qty.value = lastQty[L.no] != null ? lastQty[L.no] : 1; }

  function rowOf(lineNo) { return document.querySelector('[data-vsw-line="' + lineNo + '"]'); }

  function setRowBusy(lineNo) {
    var row = rowOf(lineNo);
    if (!row) return;
    row.classList.add('is-busy');
    row.querySelectorAll('button,input').forEach(function (el) { el.disabled = true; });
  }
  function clearRowBusy(lineNo) {
    var row = rowOf(lineNo);
    if (!row) return;
    row.classList.remove('is-busy');
    row.querySelectorAll('button,input').forEach(function (el) { el.disabled = false; });
  }

  function send(lineNo, qty) {
    if (busy) return;
    busy = true;
    setRowBusy(lineNo);
    notePending.then(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineNo, quantity: qty })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('change failed');
      window.location.reload();
    }).catch(function () {
      busy = false;
      clearRowBusy(lineNo);
      alert('Could not update the cart. Please try again.');
    });
  }

  /* Show the new number now, send once the clicking stops. */
  function queue(lineNo, qty, input) {
    lastQty[lineNo] = qty;
    if (input) input.value = qty;
    clearTimeout(timers[lineNo]);
    timers[lineNo] = setTimeout(function () { send(lineNo, qty); }, DEBOUNCE);
  }

  function lineOf(el) {
    var line = el.closest('[data-vsw-line]');
    return line ? { no: parseInt(line.getAttribute('data-vsw-line'), 10), qty: line.querySelector('[data-vsw-cart-qty]') } : null;
  }

  /* Set BEFORE the input's blur-fired `change`, so that handler knows a button owns this
     interaction. Cleared on the next tick after the click has been dealt with. */
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('[data-vsw-cart-minus],[data-vsw-cart-plus],[data-vsw-cart-remove]')) {
      pressing = true;
    }
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-vsw-cart-minus],[data-vsw-cart-plus],[data-vsw-cart-remove]');
    if (!t) return;
    var L = lineOf(t); if (!L) return;
    e.preventDefault();
    var cur = typedQty(L);
    if (cur === null) cur = parseInt(lastQty[L.no], 10) || 1;   /* blank box, use the last good value */
    if (t.hasAttribute('data-vsw-cart-remove')) {
      clearTimeout(timers[L.no]);   /* a typed quantity must not land after the removal */
      send(L.no, 0);
    } else if (t.hasAttribute('data-vsw-cart-minus')) {
      queue(L.no, Math.max(0, cur - 1), L.qty);
    } else {
      queue(L.no, cur + 1, L.qty);
    }
    setTimeout(function () { pressing = false; }, 0);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-vsw-cart-qty]')) return;
    if (pressing) return;   /* the button click carries the real intent, see defect 3 */
    var L = lineOf(e.target); if (!L) return;
    var q = typedQty(L);
    if (q === null) { revert(L); return; }
    queue(L.no, q, null);
  });

  /* Enter in the quantity box: commit straight away rather than waiting out the debounce. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-vsw-cart-qty]')) return;
    e.preventDefault();
    var L = lineOf(e.target); if (!L) return;
    var q = typedQty(L);
    if (q === null) { revert(L); return; }
    clearTimeout(timers[L.no]);
    lastQty[L.no] = q;
    send(L.no, q);
  });
}());

/* ---- Hide branding (selector page, inside the selector's own Dealer tools panel) ----
   Saksham 2026-09-02: lives in "Dealer tools" next to "Show pricing", not in the header.
   Hides the logo, the top bar (Wholesale Portal + email) and the footer; the nav stays so
   the partner can still move around while presenting. Injected here so sections/product-selector-wholesale.liquid (shared with the live
   retail-layout selector page) is never edited.
   Saksham 2026-09-10: starts ON, matching prices. The page is a dealer's in-kitchen sales
   tool, so it should open clean in front of a homeowner and the dealer switches branding
   back on if they want it. Resets to ON on every load, same as the price toggle. */
(function () {
  var panel = document.getElementById('vs-dealer-panel');
  if (!panel) return;
  document.body.classList.add('vsw-presenting');
  var row = document.createElement('label');
  row.className = 'vs-switch-row';
  row.setAttribute('for', 'vsw-logo-check');
  row.innerHTML = '<span class="vs-switch-text">Hide branding</span>' +
    '<span class="vs-switch"><input type="checkbox" id="vsw-logo-check" checked>' +
    '<span class="vs-switch-track"><span class="vs-switch-thumb"></span></span></span>';
  panel.appendChild(row);
  row.querySelector('input').addEventListener('change', function (e) {
    document.body.classList.toggle('vsw-presenting', e.target.checked);
  });
}());

/* ---- Selector "Add All to Cart" ----
   The selector adds through /cart/add.js and then fires theme:cart:open to show the retail
   cart drawer, which this layout does not render, so nothing visible happened. Go to the
   wholesale cart instead. */
(function () {
  function go() { window.location.href = (window.vsWholesaleCartUrl || '/cart'); }
  document.addEventListener('theme:cart:open', go);
  document.addEventListener('vs:b2b:cart:open', go);
}());

/* ---- FAQ: categories, accordions, search ----
   Page-editor convention (Matthew's): H2 = category, H3 = question, everything under a
   question until the next heading = the answer. If the content has only one heading level,
   every heading is a question and there are no categories. No headings at all leaves the
   document untouched. */
(function () {
  var root = document.querySelector('[data-vsw-faq]');
  if (!root) return;
  var nodes = Array.prototype.slice.call(root.children);
  var hasH2 = nodes.some(function (n) { return n.tagName === 'H2'; });
  var hasH3 = nodes.some(function (n) { return n.tagName === 'H3'; });
  var catTag = (hasH2 && hasH3) ? 'H2' : null;
  var qRe = catTag ? /^H3$/ : /^H[23]$/;
  if (!hasH2 && !hasH3) return;

  var frag = document.createDocumentFragment();
  var items = [];   /* {el, catEl, text} for search */
  var i = 0;
  var currentCat = null;

  while (i < nodes.length && !/^H[23]$/.test(nodes[i].tagName)) { frag.appendChild(nodes[i]); i++; }

  /* Built in its own function per question ON PURPOSE. `var` is function-scoped, so building
     these inline in the while loop made every button close over the LAST item/panel: clicking
     question 1 opened question 6. Do not inline this back into the loop. */
  function buildItem(heading, bodyNodes, catEl) {
    var item = document.createElement('div');
    item.className = 'vsw-acc';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vsw-acc__q';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span></span><i class="vsw-acc__mark" aria-hidden="true"></i>';
    btn.firstChild.textContent = heading.textContent;

    var panel = document.createElement('div');
    panel.className = 'vsw-acc__a';
    panel.hidden = true;
    bodyNodes.forEach(function (n) { panel.appendChild(n); });

    btn.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    item.appendChild(btn);
    item.appendChild(panel);
    items.push({ el: item, catEl: catEl, text: (heading.textContent + ' ' + panel.textContent).toLowerCase() });
    return item;
  }

  while (i < nodes.length) {
    var h = nodes[i]; i++;
    if (catTag && h.tagName === catTag) {
      currentCat = document.createElement('div');
      currentCat.className = 'vsw-faqcat';
      currentCat.textContent = h.textContent;
      frag.appendChild(currentCat);
      continue;
    }
    if (!qRe.test(h.tagName)) { frag.appendChild(h); continue; }
    var body = [];
    while (i < nodes.length && !/^H[23]$/.test(nodes[i].tagName)) { body.push(nodes[i]); i++; }
    frag.appendChild(buildItem(h, body, currentCat));
  }
  root.innerHTML = '';
  root.appendChild(frag);
  root.classList.add('vsw-faq--ready');

  /* Search filters question + answer text; a category hides when all its questions hide. */
  var searchEl = document.querySelector('[data-vsw-faq-search]');
  var emptyEl = document.querySelector('[data-vsw-faq-empty]');
  if (searchEl) {
    searchEl.addEventListener('input', function () {
      var q = searchEl.value.trim().toLowerCase();
      var visible = 0;
      var catHas = new Map();
      items.forEach(function (it) {
        var ok = !q || it.text.indexOf(q) !== -1;
        it.el.hidden = !ok;
        if (ok) visible++;
        if (it.catEl) catHas.set(it.catEl, (catHas.get(it.catEl) || 0) + (ok ? 1 : 0));
      });
      catHas.forEach(function (n, catEl) { catEl.hidden = n === 0; });
      if (emptyEl) emptyEl.hidden = visible !== 0;
    });
  }
}());


/* ---- Sales materials: page content -> download cards ----
   Page-editor convention (Matthew's): optional image, H3 = material name, paragraph =
   description, then a link to the file. Everything before the first H3 stays as the intro.
   Each card shows the cover (or a file-type icon), title, description, type + size (size from
   the link's title attribute when present) and a Download button. If the content has no H3,
   it renders as a normal document. */
(function () {
  var root = document.querySelector('[data-vsw-materials]');
  if (!root) return;
  var nodes = Array.prototype.slice.call(root.children);
  if (!nodes.some(function (n) { return n.tagName === 'H3'; })) return;

  var frag = document.createDocumentFragment();
  var grid = document.createElement('div');
  grid.className = 'vsw-mats';
  var i = 0;
  while (i < nodes.length && nodes[i].tagName !== 'H3' && !(nodes[i].querySelector && nodes[i].querySelector('img') && nodes[i + 1] && nodes[i + 1].tagName === 'H3')) {
    frag.appendChild(nodes[i]); i++;
  }
  frag.appendChild(grid);

  function typeOf(href) {
    var m = (href || '').split('?')[0].match(/\.([a-z0-9]+)$/i);
    var ext = m ? m[1].toUpperCase() : 'FILE';
    if (ext === 'XLSX' || ext === 'XLS') return 'Excel';
    return ext;
  }
  function icon(kind) {
    if (kind === 'Excel') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18"/></svg>';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8M8 17h8"/></svg>';
  }

  function buildCard(img, h3, body) {
    var link = null;
    body.forEach(function (n) { var a = n.querySelector && n.querySelector('a[href]'); if (a && !link) link = a; });
    var card = document.createElement('div');
    card.className = 'vsw-mat';
    var href = link ? link.getAttribute('href') : '';
    var kind = typeOf(href);
    var size = link && link.getAttribute('title') ? link.getAttribute('title') : '';

    var cover = document.createElement('a');
    cover.className = 'vsw-mat__cover' + (img ? '' : ' vsw-mat__cover--icon');
    if (href) { cover.href = href; cover.target = '_blank'; cover.rel = 'noopener'; }
    if (img) { img.loading = 'lazy'; cover.appendChild(img); }
    else cover.innerHTML = icon(kind) + '<span>' + kind + '</span>';
    card.appendChild(cover);

    var info = document.createElement('div');
    info.className = 'vsw-mat__info';
    var t = document.createElement('h3'); t.textContent = h3.textContent.trim(); info.appendChild(t);
    body.forEach(function (n) {
      if (n.querySelector && n.querySelector('a[href]') && n.textContent.trim().length < 40) return; /* the link line */
      var d = document.createElement('p'); d.className = 'vsw-mat__desc'; d.innerHTML = n.innerHTML; info.appendChild(d);
    });
    var meta = document.createElement('span');
    meta.className = 'vsw-mat__meta';
    meta.textContent = kind + (size ? ' \u00b7 ' + size : '');
    info.appendChild(meta);
    if (href) {
      var btn = document.createElement('a');
      btn.className = 'vsw-btn vsw-mat__btn'; btn.href = href; btn.target = '_blank'; btn.rel = 'noopener';
      btn.textContent = 'Download';
      info.appendChild(btn);
    }
    card.appendChild(info);
    return card;
  }

  var pendingImg = null;
  while (i < nodes.length) {
    var n = nodes[i]; i++;
    if (n.tagName !== 'H3') {
      var im = n.querySelector && n.querySelector('img');
      if (im) { pendingImg = im; continue; }
      frag.appendChild(n); continue;
    }
    var body = [];
    while (i < nodes.length && nodes[i].tagName !== 'H3' && !(nodes[i].querySelector && nodes[i].querySelector('img'))) { body.push(nodes[i]); i++; }
    grid.appendChild(buildCard(pendingImg, n, body));
    pendingImg = null;
  }
  root.innerHTML = '';
  root.appendChild(frag);
  root.classList.add('vsw-doc--mats');
}());

/* ---- Net terms: where the dealer lands after the order ----
   BSS's thank-you modal wires BOTH its Confirm button and its X to window.location.reload()
   (read off bss-b2b-nt-js.js, showThankYouModal). Net terms is only ever reached from the
   wholesale cart, so a reload drops the dealer back on their own now-empty cart, which reads
   like the order failed. Send them into the portal instead.

   Listen on WINDOW in the CAPTURE phase: BSS binds its handler directly to the button, and
   capture runs before the target phase, so stopPropagation here wins. Gated to the thank-you
   modal by id, so the X on the address and shipping steps still just closes as BSS intends. */
(function () {
  var AFTER_ORDER = '/pages/wholesale-home';
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest
      ? e.target.closest('.b2b-nt-button-confirm, .b2b-nt-close-btn') : null;
    if (!t || !t.closest('#b2b-nt-thankyou-modal')) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = AFTER_ORDER;
  }, true);
}());
